import { render, staticRenderFns } from "./modelolaudodescritivo.vue?vue&type=template&id=87d27c2e"
import script from "./modelolaudodescritivo.vue?vue&type=script&lang=js"
export * from "./modelolaudodescritivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports